import { getNumberOfGuests } from 'reservations/booking/helpers';

type GetNoAvailabilitiesMessageParams = {
  date: string;
  partySize: number;
  hasFirstAvailableDate: boolean;
  maxAdvanceDays: number;
};

// TODO: We'll have more conditions in the future for the following cases:
// 1. If we choose more than the maximum allowed, we ask the diner to call or email
function getNoAvailabilitiesMessage({
  date,
  partySize,
  hasFirstAvailableDate,
  maxAdvanceDays
}: GetNoAvailabilitiesMessageParams): string {
  const numberOfGuests = getNumberOfGuests(partySize);

  if (!hasFirstAvailableDate) {
    return `We currently do not have any reservations available for ${numberOfGuests} in the next ${maxAdvanceDays} days.`;
  }

  return `We currently do not have any reservations available for ${numberOfGuests} on ${date}.`;
}

export { getNoAvailabilitiesMessage };
